
export const env = {
  REACT_APP_PASSWORD_MASK_SECRET: process.env.REACT_APP_PASSWORD_MASK_SECRET,
  REACT_APP_JOB_SHARING_URL: process.env.REACT_APP_JOB_SHARING_URL,
}

export function removeHtmlTags(input) {
  return input.replace(/<\/?[^>]+(>|$)/g, '')
}

export const monthList = [
  { id: 1, label: "1", value: 1 },
  { id: 2, label: "2", value: 2 },
  { id: 3, label: "3", value: 3 },
  { id: 4, label: "4", value: 4 },
  { id: 5, label: "5", value: 5 },
  { id: 6, label: "6", value: 6 },
  { id: 7, label: "7", value: 7 },
  { id: 8, label: "8", value: 8 },
  { id: 9, label: "9", value: 9 },
  { id: 10, label: "10", value: 10 },
  { id: 11, label: "11", value: 11 },
  { id: 12, label: "12", value: 12 },
];

export const jobTypes = [
  {
    id: 1,
    label: 'Role',
    value: 'PLACEMENT',
  },
  {
    id: 2,
    label: 'Internship',
    value: 'INTERNSHIP',
    durationField: {
      label: 'Internship Duration *',
      name: 'jobDetails.internshipDuration',
      key: 'internshipDuration',
    },
    input: true,
  },
  {
    id: 3,
    label: 'Internship+PPO',
    value: 'INTERNSHIP_PPO',
    durationField: {
      label: 'Internship Duration',
      name: 'jobDetails.internshipDuration',
      key: 'internshipDuration',
    },
    input: true,
  },
  {
    id: 4,
    label: 'Apprenticeship',
    value: 'APPRENTICESHIP',
  },
  {
    id: 5,
    label: 'Projects',
    value: 'GIGS',
    isDuration: true,
    durationField: {
      label: 'Project Duration',
      name: 'jobDetails.gigsDuration',
      key: 'gigsDuration',
    },
  },
]

export const roleExportKeys = [
  'Role Published',
  'Role Name',
  'Company Name',
  'Eligible',
  'Ineligible',
  'Applied',
  'Not Applied',
  'Placed Students',
]

export const jobLevels = [
  {
    id: 1,
    label: 'Fresher',
    key: 'ENTRY',
    value: 'ENTRY',
  },
  {
    id: 2,
    label: 'Experienced',
    value: 'EXPERIENCED',
    durationField: {
      label: 'Experience Duration',
      name: 'jobDetails.experienceDuration',
      key: 'experienceDuration',
    },
    isDuration: true,
  },
  {
    id: 3,
    label: 'Both',
    value: 'BOTH',
    isAlert: true,
    alertMessage: 'Both freshers and experience candidates can apply',
    durationField: {
      label: 'Experience Duration',
      name: 'jobDetails.experienceDuration',
      key: 'experienceDuration',
    },
    isDuration: true,
  },
]
export const workStyles = [
  {
    id: 1,
    label: 'Remote',
    value: 'REMOTE',
  },
  {
    id: 2,
    label: 'Hybrid',
    value: 'HYBRID',
  },
  {
    id: 3,
    label: 'Onsite',
    value: 'ONSITE',
  },
]
export const genders = [
  {
    id: 1,
    label: 'All',
    value: 'ALL',
  },
  {
    id: 2,
    label: 'Male',
    value: 'MALE',
  },
  {
    id: 3,
    label: 'Female',
    value: 'FEMALE',
  },
]
export const types = [
  {
    id: 1,
    label: 'Campus Drive',
    subLabel: 'via TPO',
    value: false,
  },
  {
    id: 2,
    label: 'Off Campus / Lateral',
    value: true,
    subLabel: 'open to all candidates',
  },
]
export const scores = [
  {
    id: 1,
    label: 'Average',
    value: 'AVERAGE',
  },
  {
    id: 2,
    label: 'Custom',
    value: 'CUSTOM',
  },
]

export const basicRadioOptions = [
  {label:'CV Screening',value:'CV_SCREENING'},
  { label: 'Assessment', value: 'ASSESMENT' },
  { label: 'Group Discussion', value: 'GROUP' },
  { label: 'Interview', value: 'FACE_TO_FACE' },
  { label: 'External Assessment', value: 'EXTERNAL_ASSESMENT' },
]

export const assessmentTypes = [
  { label: 'Communication', value: 'COMUNICATION' },
   { label: 'Behavioral', value: 'BEHAVIORAL' },
  { label: 'Aptitude', value: 'APTITUDE' },
  { label: 'Technical', value: 'TECHNICAL' },
]

export const faceToFaceTypes = [
  { label: 'Business', value: 'BUSINESS' },
  { label: 'HR Round', value: 'HR_ROUND' },
]

export const externalAssessmentTypes = [
  { label: 'Test Gorilla', value: 'TEST_GORILA' },
  { label: 'eSkill', value: 'E_SKILL' },
]

export const payTypeOptions = [
  {
    id: 1,
    label: 'Annually',
    value: 'ANNUALLY',
  },
  {
    id: 2,
    label: 'Monthly',
    value: 'MONTHLY',
  },
]
export const ctcOptions = [
  {
    label: 'Fixed',
    value: 'FIXED',
  },
  {
    label: 'Fixed + Variable',
    value: 'FIXED_VARIABLE',
  },
]
export const jobLocations = [
  { label: 'Bangalore', value: 'Bangalore' },
  { label: 'Hyderabad', value: 'Hyderabad' },
  { label: 'Pune', value: 'Pune' },
  { label: 'Delhi', value: 'Delhi' },
  { label: 'Chennai', value: 'Chennai' },
  { label: 'Remote', value: 'Remote' },
]

export const selectedCourses = [
  { id: 1, name: 'UG', data: [] },
  { id: 2, name: 'PG', data: [] },
  { id: 3, name: 'Diploma', data: [] },
  { id: 4, name: 'Ph.d', data: [] },
]

export const initialSkills = [
  { name: 'Skill 1', value: 'Skill 1', mandatory: true },
  { name: 'Skill 2', value: 'Skill 2', mandatory: true },
  { name: 'Skill 3', value: 'Skill 3', mandatory: false },
]
export const Years = [
  {
    value: '2025',
  },
  {
    value: '2026',
  },
  {
    value: '2027',
  },
  {
    value: '2028',
  },
  {
    value: '2029',
  },
  {
    value: '2030',
  },
]
export const educationLevels = [
  { name: '10TH', value: 'tenthScore' },
  { name: '12TH', value: 'twelfthScore' },
  { name: 'UG', value: 'UGScore' },
  { name: 'PG', value: 'PGScore' },
  { name: 'DIPLOMA', value: 'UGDiplomaScore' },
  // { name: 'UG DIPLOMA', value: 'UGDiplomaScore' },
  // { name: 'PG DIPLOMA', value: 'PGDiplomaScore' },
]


export const ROUND_FIELDS = [
  'roundName',
  'interviewType',
  'assessmentType',
  'faceToFaceType',
  'roundDescription',
]

export const jobTimeTypes = [
  { label: 'Full Time', value: 'FULL_TIME' },
  { label: 'Part Time', value: 'PART_TIME' },
]
export const employmentTypes = [
  { label: 'On Rolls', value: 'ONROLL' },
  { label: 'Off Roll/Contractual', value: 'CONTRACT' },
]
// Popup configurations for different actions
export const POPUP_CONFIGS = {
  DELETE_GROUP: {
    description: 'Are you sure to delete this group?',
    closeText: 'No',
    yesText: 'Yes',
    closeButtonHeight: '38px',
    closeButtonWidth: '80px',
    yesButtonHeight: '38px',
    yesButtonWidth: '80px',
  },
  DUPLICATE_GROUP: {
    closeText: 'No',
    yesText: 'Yes',
    closeButtonHeight: '38px',
    closeButtonWidth: '80px',
    yesButtonHeight: '38px',
    yesButtonWidth: '80px',
  },
  REMOVE_INSTITUTE: {
    closeText: 'No',
    yesText: 'Yes',
    closeButtonHeight: '38px',
    closeButtonWidth: '80px',
    yesButtonHeight: '38px',
    yesButtonWidth: '80px',
  },
  CREATE_NEW_GROUP: {
    closeText: 'No',
    yesText: 'Yes',
    closeButtonHeight: '38px',
    closeButtonWidth: '80px',
    yesButtonHeight: '38px',
    yesButtonWidth: '80px',
  },
}
